import styled from "styled-components";
import { theme } from "../../../../../../constants/StyledComponents";

export const StyledFooterHistoryApprovalContainer = styled.div`
  width: 100%;
  border-top: 1px solid ${theme.colors.purple_2};
  height: 80px;
  align-items: center;
  display: flex;
`;

export const StyledFooterHistoryApprovalContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px;
  width: 100%;
  margin-left: 40px;
  & .buttons-container {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
`;

export const StyledFooterLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
`;
